import * as React from 'react';

const styles = require('./ScrollableBlock.css');

const BOTTOM_INDENT = 100;

interface IScrollContainerProps {
  onPageScroll(): void;
  itemHeight: number;
  nextPagePending?: boolean;
  canRequestNextPage?: boolean;
  startItemsCount?: number;
  children: React.ReactNode;
}

interface IPage {
  // разница между видимой частью и высотой страницы
  diffBetweenVisibleHeight: number;
  // количество элементов на странице
  itemsCount: number;
  // высота страницы
  pageHeight: number;
  // позиция страницы относительно верхней части контейнера
  positionTop: number;
}

interface IScrollContainerState {
  // массив страниц
  pages: IPage[];
}

export class ScrollableBlock extends React.Component<IScrollContainerProps, IScrollContainerState> {
  private containerElement: HTMLDivElement | null;
  /**
   * Количество элементов, которое должно остаться недоскроллеными, после которых вызвать onPageScroll()
   */
  private whenRequestNextPage = 2;

  public constructor(props: IScrollContainerProps) {
    super(props);

    const itemsCount = React.Children.count(props.children);
    const pageHeight = (itemsCount - this.whenRequestNextPage) * props.itemHeight;

    this.state = {
      pages: [
        {
          diffBetweenVisibleHeight: 0,
          itemsCount,
          pageHeight,
          positionTop: 0,
        },
      ],
    };
  }

  public UNSAFE_componentWillReceiveProps(nextProps: IScrollContainerProps) {
    const prevItemsCount = React.Children.count(this.props.children);
    const nextItemsCount = React.Children.count(nextProps.children);

    if (!this.containerElement) {
      return;
    }

    const elementHeight = this.containerElement.getBoundingClientRect().height;

    // Если добавленно в начало n элементов, то сохраняем скролл на нужной позиции
    if (nextProps.startItemsCount) {
      this.containerElement.scrollTop += nextProps.startItemsCount * nextProps.itemHeight;
    }

    // Элементы удалятся из списка не могут
    if (prevItemsCount !== nextItemsCount) {
      const itemsCount = nextItemsCount - prevItemsCount;
      const pageHeight = (itemsCount - this.whenRequestNextPage) * nextProps.itemHeight;
      const diffBetweenVisibleHeight = pageHeight - elementHeight;
      const positionTop = this.getNextPagePosition();

      const pages = this.state.pages.concat([
        {
          diffBetweenVisibleHeight,
          itemsCount,
          pageHeight,
          positionTop,
        },
      ]);

      this.setState({
        pages,
      });
    }
  }

  public render() {
    return (
      <div ref={r => (this.containerElement = r)} className={styles['container']} onScroll={this.onScroll}>
        {this.props.children}
      </div>
    );
  }

  private onScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;

    // Если все элементы страницы попадают в границы контейнера
    if (scrollHeight === clientHeight) {
      return;
    }

    const scrollPositionForNeedRequestNextPage = scrollHeight - clientHeight - BOTTOM_INDENT;

    // Если страница проскроллена
    if (scrollTop >= scrollPositionForNeedRequestNextPage) {
      this.props.onPageScroll();
    }
  };

  private getNextPagePosition() {
    return this.state.pages.reduce((pos, page) => pos + page.pageHeight, 0);
  }
}
